import lightbulb from "@/assets/images/lightbulb.svg";
import { Icon } from "@uigovpe/components";
import type { ReactNode } from "react";

export type TipCardProps = {
  title: string;
  description: ReactNode;
  className?: string;
  variant?: "default" | "checklist";
  items?: ReactNode[];
};

export function TipCard({
  title,
  description,
  className = "",
  variant = "default",
  items = [],
}: TipCardProps) {
  if (variant === "checklist")
    return (
      <section
        className={`rounded-lg! border! border-violet-light! bg-violet-ultralight/50! p-4! shadow-sm! ${className}`}
      >
        <header className="flex! items-center! gap-3!">
          <span
            className="flex! size-8! shrink-0! items-center! justify-center! rounded-md! bg-primary! text-white!"
          >
            <img
              src={lightbulb}
              alt=""
              className="size-5!"
              aria-hidden="true"
            />
          </span>
          <strong className="text-xs! text-zinc-700!">{title}</strong>
        </header>
        <div className="mt-4! text-xs! leading-5! text-zinc-700!">
          {description}
        </div>
        {items.length > 0 && (
          <ul className="mt-3! flex! flex-col! gap-3!">
            {items.map((item, index) => (
              <li
                key={index}
                className="flex! items-start! gap-2! text-xs! text-zinc-800!"
              >
                <Icon
                  icon="check_circle"
                  className="mt-px! shrink-0! text-primary!"
                />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        )}
      </section>
    );
  return (
    <div
      className={`flex! w-[80%]! flex-col! gap-2! rounded-xl! border! border-zinc-200! bg-background! px-4! py-10! shadow-xl! animate-in! fade-in! slide-in-from-right-4! delay-300! duration-1000! ${className}`}
    >
      <div className="flex! items-center! gap-3!">
        <span
          className="flex! size-9! shrink-0! items-center! justify-center! rounded-md! bg-primary! shadow-sm!"
        >
          <img src={lightbulb} alt="" className="size-5!" aria-hidden="true" />
        </span>
        <strong className="text-sm!">{title}</strong>
      </div>
      <div className="text-sm! text-[#28272c]!">{description}</div>
    </div>
  );
}
